<template>
    <div class="terms container" id="million-bit-terms">
        <h2>Terms & Conditions</h2>
        <p>
          Effective Date: July 1st, 2024
        </p>
<p>
Welcome to the Million Bit Homepage! We are committed to protecting your privacy and ensuring your experience on our website is safe. This Privacy Policy outlines how we collect, use, and protect your information. By using our website, you agree to the terms in this Privacy Policy.
</p>
<h3>1. Information We Collect</h3>
<p>
We may collect different types of information when you visit the Million Bit Homepage, including:
</p>
<p>
Personal Information: When you contact us or interact with certain parts of the website, we may collect your name, email address, or other contact details.
Usage Data: This includes information about how you interact with our website, such as your IP address, browser type, pages viewed, and other usage details.
</p>
<h3>2. How We Use Your Information</h3>
<p>
We use the collected information for various purposes, such as:
</p>
<ul>
  <li>To provide and improve our website’s features and content</li>
  <li>To communicate with you regarding inquiries, updates, or promotions</li>
  <li>To analyze and understand how users interact with the website, allowing us to make improvements</li>
</ul>
<h3>3. Sharing Your Information</h3>
<p>
We value your privacy and will not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as necessary to:
</p>
<p>
  <ul>
    <li>Comply with legal obligations or government requests</li>
    <li>Enforce our website’s policies or protect our rights and safety</li>
    <li>Collaborate with trusted service providers who assist us in operating our website</li>
  </ul>
</p>
<h3>4. Security</h3>
<p>
We take reasonable measures to protect your information from unauthorized access or disclosure. However, please remember that no data transmission over the internet can be guaranteed to be completely secure.
</p>
<h3>5. Your Rights</h3>
<p>
Depending on your location, you may have certain rights regarding your personal information, such as:
</p>

<p>
  <ul>
    <li>The right to access, update, or delete your personal data</li>
    <li>The right to object to processing or request data portability</li>
    <li>To exercise these rights, please contact us at millionbithomepage@gmail.com.</li>
  </ul>
</p>

<h3>6. Third-Party Links</h3>
<p>
Our website may contain links to other websites. We are not responsible for the privacy practices or content of those sites. Please review their privacy policies independently.
</p>

<h3>7. Updates to this Privacy Policy</h3>
<p>
We may update this Privacy Policy periodically. We will notify you of significant changes by posting the new policy on this page and updating the effective date above.
</p>

<h3>8. Contact Us</h3>
<p>
If you have any questions about this Privacy Policy, please contact us at:
</p>

<p>
Email: millionbithomepage@gmail.com
</p>
        <hr />
    </div>
  </template>
  
  <script>
  export default {
    name: 'terms',
    data () {
      return {
        
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('terms');
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-terms {
      background: #fff !important;
      padding: 20px;
      text-align: left;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Terms.vue?0722f9f7